import React from "react";
import FourZeroFour from "../../../../../shared_ui/components/fourZeroFour";

export default class NotFoundPage extends React.Component {
  render() {
    return <FourZeroFour />;
  }
}
